export const SingleColor = '#9d99ad'

export const NotApplicableColor = '#776eb8'

export const QualitativeColors = [
  '#9d99ad',
  '#157ab7',
  '#ffd232',
  '#6f4f7c',
  '#9dd866',
  '#ca482f',
  '#8edec7',
  '#e7ac32',
  '#4daa00',
  '#b81e74'
]

export const DivergingColors = ['#2093d8', '#dddddd', '#ff8c16']

export const SequentialColor = '#226e41'

export const WeightedColor = '#3d3d5c'

export const DefaultBranding = () => ({
  monochromatic: SingleColor,
  sequentialPalette: SequentialColor,
  divergentPalette: DivergingColors.slice(),
  qualitativePalette: QualitativeColors.slice()
})
